<!--
 * @Description: 
 * @Author: zml
 * @Date: 2023-08-12 17:20:19
 * @LastEditors: zml
 * @LastEditTime: 2023-08-14 12:26:18
-->
<template>
  <div class="audit">
    <div class="msg" :style="{background: bgColor}">{{statusName}}</div>
  </div>
</template>

<script>
import { VerifyMember } from '@/api/login'
export default {
  data: () => ({
    statusName: '您的账号已审核通过',
    bgColor: '#e2ffe5'
  }),
  created() {
    this.verifyMemberFun()
  },
  methods: {
    verifyMemberFun() {
      const loading = this.$loading({
        lock: true,
        text: this.$t('GA.loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      VerifyMember({ key: this.$route.query.key })
        .then(res => {
          if (res.success) {
            this.statusName = this.$hs(
              '您的账号审核通过，请前往登录',
              'Your account has been approved. Please log in at',
              'Su cuenta ha sido aprobada, por favor vaya a iniciar sesión'
            )
            this.bgColor = '#e2ffe5'
          } else {
            this.statusName = this.$hs(
              '您的账号审核失败',
              'Your account review failed',
              'La auditoría de su cuenta falló'
            )
            this.bgColor = '#fef0f0'
          }
        })
        .catch(() => {
          this.statusName = this.$hs(
            '您的账号审核失败',
            'Your account review failed',
            'La auditoría de su cuenta falló'
          )
          this.bgColor = '#fef0f0'
        })
        .finally(() => {
          loading.close()
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.audit {
  // height: calc(100vh - 100px);
}
.msg {
  margin: 42px 0;
  height: 50px;
  line-height: 50px;
  background-color: #fef0f0;
  text-align: center;
}
</style>